import React from "react";
import Webmenu from "../../layouts/webmenu";
import Topbar from "../../layouts/topbar";
import { ThreeDots } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { styleSelect } from "../../constants/customStyles";
import { useNavigate, useParams } from "react-router-dom";
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import { useEffect } from "react";
import { getAllState, saveState } from "../../actions/StateAction";
import { getAllVehicleCode, saveVehicleCode } from "../../actions/VehicleCodeActions";
import { getAllVehicleType, saveVehicleType } from "../../actions/VehicleTypeActions";
import { getAllVehicleMake, saveVehicleMake } from "../../actions/VehicleMakeActions";
import { getAllVehicleModel, getVehicleModelByMakeId, saveVehicleModel } from "../../actions/VehicleModelActions";
import { getAllColor, saveColor } from "../../actions/ColorActions";
import { useState } from "react";
import { getAllReplaceableVehicle } from "../../actions/ReplaceableVehicleActions";
import { getAllDriver } from "../../actions/DriverActions";
import { getAllLeasePlan, getVehicleReplacementById, saveVehicleReplacement, updateVehicleReplacement } from "../../actions/VehicleReplacementsActions";
import Toast from "../../components/Toast";
import Mobilemenu from "../../layouts/mobile-menu";

function EditReplacementOfVehicle() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();

    useEffect(() => {
            dispatch(getVehicleReplacementById(params.id));
         }, []);

    const vehicleReplacement = useSelector(state => state?.vehicleReplacements?.vehicleReplacement);

    const [plateNo, setPlateNo] = useState('');
    const [chasisNo, setChasisNo] = useState('');
    const [regExpiry, setRegExpiry] = useState('');
    const [stateId, setStateId] = useState('');
    const [color, setColor] = useState('');
    const [vehicleCode, setVehicleCode] = useState('');
    const [vehicleType, setVehicleType] = useState('');
    const [vehicleMake, setVehicleMake] = useState('');
    const [vehicleModel, setVehicleModel] = useState('');
    const [replacedVehicle, setReplacedVehicle] = useState('');
    const [driver, setDriver] = useState('');
    const [type, setType] = useState('');
    const [leaseCompany, setLeaseCompany] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [customerMobile, setCustomerMobile] = useState('');

    useEffect(() => {
            dispatch(getAllState(null, 9999, { status: 1 }));
            dispatch(getAllColor(null, 9999, { status: 1 }));
            dispatch(getAllVehicleCode(null, 9999, { status: 1 }));
            dispatch(getAllVehicleType(null, 9999, { status: 1 }));
            dispatch(getAllVehicleMake(null, 9999, { status: 1 }));
            dispatch(getAllVehicleModel(null, 9999, { status: 1 }));
            dispatch(getAllReplaceableVehicle(null, 9999, { status: 1 }));
            dispatch(getAllDriver(null, 9999));
         }, []);

    const state = useSelector(state => state?.state?.states?.data);
    const colors = useSelector(state => state?.color?.colors?.data);
    const vehicleTypes = useSelector(state => state?.vehicleType?.vehicleTypes?.data);
    const vehicleMaker = useSelector(state => state?.vehicleMaker?.vehicleMakers?.data);
    const vehicleCodes = useSelector(state => state?.vehicleCode?.vehicleCodes?.data);
    const vehicleModels = useSelector(state => state?.vehicleModel?.vehicleModels?.data);
    const replaceableVehicles = useSelector(state => state?.replaceableVehicles?.replaceableVehicles?.data);
    const drivers = useSelector(state => state?.drivers?.drivers);
    const leaseCompanies = useSelector(state => state?.vehicleReplacements?.leaseCompanies?.data);
    const loading = useSelector(state => state?.loading?.loading);

    useEffect(() => {
        if (vehicleReplacement && Object.keys(vehicleReplacement).length > 0) {
            setPlateNo(vehicleReplacement?.vehicle?.plate_number);
            setLeaseCompany(vehicleReplacement?.company_id ? { value: vehicleReplacement?.company_id, label: 'Lease Plan' } : '')
            setCustomerName(vehicleReplacement?.customer?.name);
            setCustomerMobile(vehicleReplacement?.customer?.mobile);
            setChasisNo(vehicleReplacement?.vehicle?.chasis_no);
            setType(vehicleReplacement?.type)
            setRegExpiry(vehicleReplacement?.vehicle?.registration_expiry);
            setStateId(vehicleReplacement?.vehicle?.state_id ? { state_id: vehicleReplacement?.vehicle?.state_id, name: vehicleReplacement?.vehicle?.state?.name } : '');
            setColor(vehicleReplacement?.vehicle?.color_id ? { color_id: vehicleReplacement?.vehicle?.color_id, name: vehicleReplacement?.vehicle?.color?.name } : '');
            setVehicleCode(vehicleReplacement?.vehicle?.code_id ? { vehicle_code_id: vehicleReplacement?.vehicle?.code_id, name: vehicleReplacement?.vehicle?.vehicle_code?.name } : '');
            setVehicleType(vehicleReplacement?.vehicle?.vehicle_type_id ? { vehicle_type_id: vehicleReplacement?.vehicle?.vehicle_type_id, name: vehicleReplacement?.vehicle?.vehicle_type?.name } : '');
            setVehicleMake(vehicleReplacement?.vehicle?.vehicle_make_id ? { vehicle_make_id: vehicleReplacement?.vehicle?.vehicle_make_id, name: vehicleReplacement?.vehicle?.vehicle_make?.name } : '');
            setVehicleModel(vehicleReplacement?.vehicle?.vehicle_model_id ? { vehicle_model_id: vehicleReplacement?.vehicle?.vehicle_model_id, name: vehicleReplacement?.vehicle?.vehicle_model?.name } : '');
            setReplacedVehicle(vehicleReplacement?.replaceable_vehicle_id ? { replaceable_vehicle_id: vehicleReplacement?.replaceable_vehicle_id, plate_number: vehicleReplacement?.replaceable_vehicle?.plate_number } : '');
            setDriver(vehicleReplacement?.driver_in ? { driver_id: vehicleReplacement?.driver_in, driver_name: vehicleReplacement?.driver_name } : '');
        }
    }, [vehicleReplacement])

    const FuelOptions = [
        { label: '1/3', value: '1/3' },
        { label: '1/2', value: '1/2' },
        { label: '3/4', value: '3/4' },
        { label: 'E', value: 'E' },
    ]
    const handleChangeState = (e) => {
        setStateId({
            state_id: e.state_id,
            name: e.name
        })
    }
    const handleChangeVehicleCode = (e) => {
        setVehicleCode({
            vehicle_code_id: e.vehicle_code_id,
            name: e.name
        })
    }
    const handleChangeColor = (e) => {
        setColor({
            color_id: e.color_id,
            name: e.name
        })
    }
    const handleChangeVehicleType = (e) => {
        setVehicleType({
            vehicle_type_id: e.vehicle_type_id,
            name: e.name
        })
    }

    const handleChangeVehicleMake = (e) => {
        setVehicleMake({
            vehicle_make_id: e.vehicle_make_id,
            name: e.name
        })
        dispatch(getVehicleModelByMakeId(e.vehicle_make_id));
    }
    const vehicleModelByMakeId = useSelector(state => state?.vehicleModel?.VehicleModelByMake)

    const [vehicleModelOptions, setVehicleModelOptions] = useState('');

    useEffect(() => {
        if (vehicleModelByMakeId && vehicleModelByMakeId.length > 0) {
            setVehicleModelOptions(vehicleModelByMakeId)
        } else {
            setVehicleModelOptions(vehicleModels)
        }
    }, [vehicleModelByMakeId, vehicleModels])

    const handleChangeVehicleModel = (e) => {
        setVehicleModel({
            vehicle_model_id: e.vehicle_model_id,
            name: e.name
        })
    }

    const [isLoading, setIsLoading] = useState(false);

    const handleCreateState = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveState(data));
            dispatch(getAllState(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleCode = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveVehicleCode(data));
            dispatch(getAllVehicleCode(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleType = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            dispatch(saveVehicleType(data))
            dispatch(getAllVehicleType(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleMake = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveVehicleMake(data))
            dispatch(getAllVehicleMake(null, 9999))
        }, 1000);
    }
    const handleCreateVehicleModel = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveVehicleModel(data));
            dispatch(getAllVehicleModel(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleColor = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveColor(data));
            dispatch(getAllColor(null, 9999));
        }, 1000);
    }
    const handleChangeReplacedVehicle = (e) => {
        // e)
        setReplacedVehicle({
            replaceable_vehicle_id: e.replaceable_vehicle_id,
            name: e.plate_number,
        });
    };
    const handleChangeDriver = (e) => {
        setDriver({
            driver_id: e.id,
            name: e.partner_id[1],
        });
    };
    const handleChangeLeaseCompanies = (e) => {
        setLeaseCompany({
            value: 81,
            label: 'Lease Plan',
        });
    };

    const save = () => {
        if (plateNo.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Plate No is Required!'
            })
            // } else if (!leaseCompany) {
            //     Toast.fire({
            //         icon: 'error',
            //         title: 'Company is Required!'
            //     })
        } else if (customerName.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Customer Name is Required!'
            })
        } else if (customerMobile.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Customer Mobile is Required!'
            })
        } else if (chasisNo.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Chasis No is Required!'
            })
        } else if (regExpiry.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Reg. Expiry is Required!'
            })
        } else if (vehicleCode.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Code is Required!'
            })
        } else if (vehicleType.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Type is Required!'
            })
        } else if (vehicleMake.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Make is Required!'
            })
        } else if (vehicleModel.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Model is Required!'
            })
        } else if (replacedVehicle.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Replacement Vehicle is Required!'
            })
        } else if (!driver) {
            Toast.fire({
                icon: 'error',
                title: 'Driver is Required!'
            })
        } else {
            let data = {
                company_id: 81,
                customer_name: customerName,
                customer_mobile: customerMobile,
                plate_number: plateNo,
                chasis_no: chasisNo,
                registration_expiry: regExpiry,
                state_id: stateId.state_id,
                code_id: vehicleCode.vehicle_code_id,
                color_id: color.color_id,
                vehicle_type_id: vehicleType.vehicle_type_id,
                vehicle_make_id: vehicleMake.vehicle_make_id,
                vehicle_model_id: vehicleModel.vehicle_model_id,
                type: type,
                replaceable_vehicle_id: replacedVehicle.replaceable_vehicle_id,
                driver_id: driver?.driver_id,
            }
            dispatch(updateVehicleReplacement(data, params.id, navigate));
        }
    }
    return (
        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    {
                        loading ?
                            <ThreeDots
                                height="80"
                                width="80"
                                radius="9"
                                color="#2d3748"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                wrapperClassName=""
                                visible={loading}
                            /> :
                            <span>
                                <div className="intro-y d-flex align-items-center mt-5">
                                    <h2 className="fs-lg fw-medium me-auto">
                                        Replacement Of Vehicle
                                    </h2>
                                </div>
                                <div className="intro-y d-flex align-items-center mt-3">
                                    <h2 className="fs-base fw-medium me-auto">
                                        Customer Info
                                    </h2>
                                </div>
                                {/* <!-- BEGIN: Form Layout --> */}
                                <div className="intro-y box p-5 mt-3">
                                    <div className="grid columns-12">
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Company <span className="text-theme-6">*</span> :</label>
                                            <Select
                                                value={{ value: 81, label: 'Lease Plan' }}
                                                onChange={(e) => handleChangeLeaseCompanies(e)}
                                                options={[{ value: 81, label: 'Lease Plan' }]}
                                                isDisabled={true}
                                                // getOptionLabel={(option) => `${option.name}`}
                                                // getOptionValue={(option) => `${option.insurance_company_id}`}
                                                // options={insuranceCompanies && insuranceCompanies.length > 0 ? insuranceCompanies : []}
                                                styles={styleSelect}
                                                name=""
                                            />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Customer Mobile <span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" value={customerMobile} onChange={(e) => setCustomerMobile(e.target.value)} type="text" className="form-control w-full" placeholder="Enter Customer Mobile" />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Customer Name <span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" value={customerName} onChange={(e) => setCustomerName(e.target.value)} type="text" className="form-control w-full" placeholder="Enter Customer Name" />
                                        </div>
                                        {/* <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Service Expiry<span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" type="date" className="form-control w-full" />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Service Mile<span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" type="text" className="form-control w-full" placeholder="Enter Service Mile" />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">State<span className="text-theme-6">*</span> :</label>
                                            <Select styles={styleSelect} name="" />
                                        </div> */}
                                    </div>
                                </div>
                                {/* <!-- BEGIN: Form Layout --> */}
                                <div className="intro-y d-flex align-items-center mt-3">
                                    <h2 className="fs-base fw-medium me-auto">
                                        Customer Vehicle Info
                                    </h2>
                                </div>
                                <div className="intro-y box p-5 mt-3">
                                    <div className="grid columns-12">
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Vehicle Plate No. <span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" type="text" value={plateNo} onChange={(e) => setPlateNo(e.target.value)} className="form-control w-full" placeholder="Enter Plate No." />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Vehicle Chasis No. <span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" type="text" value={chasisNo} onChange={(e) => setChasisNo(e.target.value)} className="form-control w-full" placeholder="Enter Chasis No." />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Vehicle Reg Expiry <span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" type="date" value={regExpiry} onChange={(e) => setRegExpiry(e.target.value)} className="form-control w-full" placeholder="Enter Reg Expiry" />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">State :</label>
                                            <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateState} styles={styleSelect}
                                                onChange={(e) => handleChangeState(e)} getOptionLabel={(option) => `${option.name}`} value={stateId}
                                                getOptionValue={(option) => `${option.state_id}`} options={state && state.length > 0 ? state : []} />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Color :</label>
                                            <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleColor} styles={styleSelect}
                                                onChange={(e) => handleChangeColor(e)} getOptionLabel={(option) => `${option.name}`} value={color}
                                                getOptionValue={(option) => `${option.color_id}`} options={colors && colors.length > 0 ? colors : []} />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Vehicle Code<span className="text-theme-6">*</span> :</label>
                                            <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleCode} styles={styleSelect}
                                                onChange={(e) => handleChangeVehicleCode(e)} getOptionLabel={(option) => `${option.name}`} value={vehicleCode}
                                                getOptionValue={(option) => `${option.vehicle_code_id}`} options={vehicleCodes && vehicleCodes.length > 0 ? vehicleCodes : []} />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Vehicle Type<span className="text-theme-6">*</span> :</label>
                                            <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleType} styles={styleSelect}
                                                onChange={(e) => handleChangeVehicleType(e)} getOptionLabel={(option) => `${option.name}`} value={vehicleType}
                                                getOptionValue={(option) => `${option.vehicle_type_id}`} options={vehicleTypes && vehicleTypes.length > 0 ? vehicleTypes : []} />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Vehicle Make<span className="text-theme-6">*</span> :</label>
                                            <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleMake} styles={styleSelect}
                                                onChange={(e) => handleChangeVehicleMake(e)} getOptionLabel={(option) => `${option.name}`} value={vehicleMake}
                                                getOptionValue={(option) => `${option.vehicle_make_id}`} options={vehicleMaker && vehicleMaker.length > 0 ? vehicleMaker : []} />
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Vehicle Model<span className="text-theme-6">*</span> :</label>
                                            <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleModel} styles={styleSelect}
                                                onChange={(e) => handleChangeVehicleModel(e)} getOptionLabel={(option) => `${option.name}`} value={vehicleModel}
                                                getOptionValue={(option) => `${option.vehicle_model_id}`} options={vehicleModelOptions && vehicleModelOptions.length > 0 ? vehicleModelOptions : []} />
                                        </div>
                                    </div>
                                </div>
                                <div className="intro-y d-flex align-items-center mt-3">
                                    <h2 className="fs-base fw-medium me-auto">
                                        Repalcement Vehicle Info
                                    </h2>
                                </div>
                                <div className="intro-y box p-5 mt-3">
                                    <div className="grid columns-12">
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Replacement Vehicle <span className="text-theme-6">*</span> :</label>
                                            <Select styles={styleSelect} getOptionLabel={(option) => `${option.plate_number}`} onChange={(e) => handleChangeReplacedVehicle(e)} value={replacedVehicle}
                                                getOptionValue={(option) => `${option.replaceable_vehicle_id}`} options={replaceableVehicles && replaceableVehicles.length > 0 ? replaceableVehicles : []} />
                                        </div>
                                        <div class="g-col-12 g-col-md-4 mt-3"> <label>Type :</label>
                                            <div class="d-flex flex-coloumn flex-sm-row mt-2">
                                                <div class="form-check me-2"> <input id="radio-switch-4" class="form-check-input" type="radio" onChange={(e) => setType(e.target.value)} checked={type === "dedicated"} name="horizontal_radio_button" value="dedicated" /> <label class="form-check-label" for="radio-switch-4">Dedicated</label> </div>
                                                <div class="form-check me-2 mt-2 mt-sm-0"> <input id="radio-switch-5" class="form-check-input" type="radio" onChange={(e) => setType(e.target.value)} checked={type === "general"} name="horizontal_radio_button" value="general" /> <label class="form-check-label" for="radio-switch-5">General</label> </div>
                                            </div>
                                        </div>
                                        <div className="g-col-12 g-col-md-4">
                                            <label for="crud-form-1" className="form-label">Driver <span className="text-theme-6">*</span> :</label>
                                            <Select
                                                value={driver}
                                                styles={styleSelect}
                                                onChange={(e) => handleChangeDriver(e)}
                                                options={drivers && drivers.length > 0 ? drivers : []}
                                                getOptionValue={(option) => `${option?.id}`}
                                                getOptionLabel={(option) => `${option && option?.driver_name}`}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="text-end mt-5">
                                    <button type="button" onClick={() => navigate('/replacementOfVehicle')} className="btn btn-secondary bg-white w-24 me-1">Back</button>
                                    <button onClick={save} type="button" disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button>
                                </div>
                            </span>
                    }
                </div>
            </div>
        </React.Fragment>
    )
}
export default EditReplacementOfVehicle;